import { z } from 'zod';

export const customListTypes = ['MULTI_PICKLIST', 'PICKLIST'] as const;
export const customFieldTypes = [...customListTypes] as const;
export const nativeFieldTypes = ['DATETIME', 'BOOLEAN'] as const;
export const fieldTypes = [...customFieldTypes, ...nativeFieldTypes];
export const fieldTypeSchema = z.enum(fieldTypes);

export const nativeFieldTypeMap: Record<string, (typeof fieldTypes)[number]> = {
  teamId: 'PICKLIST',
  itemStatusId: 'PICKLIST',
  itemTypeId: 'PICKLIST',
  earliestStartDateTime: 'DATETIME',
  deadlineDateTime: 'DATETIME',
  doneDateTime: 'DATETIME',
  forecastedStartDateTime: 'DATETIME',
  forecastedFinishDateTime: 'DATETIME',
  plannedStartDateTime: 'DATETIME',
  plannedFinishDateTime: 'DATETIME',
  latestFinishDateTime: 'DATETIME',
  isUnparented: 'BOOLEAN',
};

export const nativeFieldIds = Object.keys(
  nativeFieldTypeMap,
) as (keyof typeof nativeFieldTypeMap)[];
export const nativeDateTimeFieldIds = nativeFieldIds.filter(
  (fieldId) => nativeFieldTypeMap[fieldId] === 'DATETIME',
);
export const nativeBooleanFieldIds = nativeFieldIds.filter(
  (fieldId) => nativeFieldTypeMap[fieldId] === 'BOOLEAN',
) as (keyof typeof nativeFieldTypeMap)[];
